import { render, staticRenderFns } from "./eventReserveBox.vue?vue&type=template&id=16b1a85e&scoped=true&"
import script from "./eventReserveBox.vue?vue&type=script&lang=js&"
export * from "./eventReserveBox.vue?vue&type=script&lang=js&"
import style0 from "./eventReserveBox.vue?vue&type=style&index=0&id=16b1a85e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b1a85e",
  null
  
)

export default component.exports